export type MappedRoundTripNearestSearch = {
  id: number;
  departureDate: string;
  price: number | null;
  isActive: boolean;
  isMinPrice: boolean;
};

export type RoundTripNearestSearchKey = keyof MappedRoundTripNearestSearch;
export type RoundTripNearestSearchValue =
  MappedRoundTripNearestSearch[RoundTripNearestSearchKey];

export type Price = number | null | undefined;

export enum GraphDirectionEnum {
  TO = 'To',
  BACK = 'Back',
}

export type GraphDirection = GraphDirectionEnum;
